import useStorePermission from '../zustand/useStorePremission';

export const hasPermission = (
  permissions: any,
  key: string,
  action: 'can_view' | 'can_delete' | 'can_create_and_update',
) => {
  return permissions?.[key]?.[action] === true;
};

// const getPermissions = () => {
//   const { permissionCurrentUser } = useStorePermission.getState();
//   return {
//     permissions: permissionCurrentUser?.permissions,
//     isOwner: permissionCurrentUser?.is_owner,
//   };
// };

const PERMISSION_CONFIG = {
  dashboard: {
    key: 'DASHBOARD_METRIC',
    routes: ['/dashboard'],
  },
  users: {
    key: 'BIZ_USER',
    routes: ['/users'],
  },
  banner: {
    key: 'DATA_NEWS',
    routes: ['/banner', '/banner/create', '/banner/edit'],
  },
  notifications: {
    key: 'DATA_NEWS',
    routes: ['/notifications', '/notifications/create'],
  },
  music: {
    key: 'DATA_MUSIC',
    routes: ['/music', '/music/create', '/music/edit'],
  },
  news: {
    key: 'DATA_NEWS',
    routes: ['/news', '/news/create', '/news/edit'],
  },
  quote: {
    key: 'DATA_QUOTE',
    routes: ['/quote', '/quote/create', '/quote/edit'],
  },
  zodiac: {
    key: 'DATA_ZODIAC',
    routes: [
      '/zodiac',
      '/zodiac/cms',
      '/zodiac/cms/create',
      '/zodiac/cms/edit',
      '/zodiac/celebrity',
      '/zodiac/celebrity/create',
      '/zodiac/celebrity/edit',
      '/zodiac/horoscopes',
      '/zodiac/horoscopes/create',
      '/zodiac/horoscopes/edit',
    ],
  },
  numerology: {
    key: 'DATA_NUMEROLOGY',
    routes: [
      '/numerology',
      '/numerology/cms',
      '/numerology/cms/create',
      '/numerology/cms/edit',
      '/numerology/celebrity',
      '/numerology/celebrity/create',
      '/numerology/celebrity/edit',
      '/numerology/relations',
      '/numerology/relations/create',
      '/numerology/relations/edit',
    ],
  },
  prayer: {
    key: 'DATA_PRAYER',
    routes: [
      '/prayers',
      '/prayers/categories',
      '/prayers/categories/create',
      '/prayers/categories/edit',
      '/prayers/list',
      '/prayers/create',
      '/prayers/edit',
    ],
  },
  package: {
    key: 'BIZ_IAP_PACKAGE',
    routes: [
      '/package',
      '/package/iap',
      '/package/iap/create',
      '/package/iap/edit',
      '/package/receipt',
    ],
  },
  tarot: {
    key: 'DATA_TAROT',
    routes: [
      '/tarot',
      '/tarot/card',
      '/tarot/card/edit',
      '/tarot/topic',
      '/tarot/question',
      '/tarot/list',
      '/tarot/list/edit',
    ],
  },
  system_admin: {
    key: 'SYSTEM_ADMIN',
    routes: ['/system', '/system/administrator'],
  },
  permission: {
    key: 'SYSTEM_PERMISSION',
    routes: [
      '/system/permission',
      '/system/permission/create',
      '/system/permission/update',
      '/system/permission/member',
    ],
  },
};

export const routePermissionMap: Record<
  string,
  { key: string; action: 'can_view' | 'can_delete' | 'can_create_and_update' }
> = {};

Object.values(PERMISSION_CONFIG).forEach(({ key, routes }) => {
  routes.forEach((route) => {
    const isWriteAction =
      route.includes('create') || route.includes('edit') || route.includes('update');
    routePermissionMap[route] = {
      key,
      action: isWriteAction ? 'can_create_and_update' : 'can_view',
    };
  });
});

export function shouldHideMenuByKeys(keys: string[]): boolean {
  const { permissionCurrentUser } = useStorePermission.getState();
  const permissions = permissionCurrentUser?.permissions;
  const isOwner = permissionCurrentUser?.is_owner;
  if (isOwner) {
    return false;
  }
  for (const key of keys) {
    if (permissions?.[key]?.can_view === true) {
      return false;
    }
  }
  return true;
}
